/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { InformationExtractionSchemaDetail } from './InformationExtractionSchemaDetail';
import {
  InformationExtractionSchemaDetailFromJSON,
  InformationExtractionSchemaDetailFromJSONTyped,
  InformationExtractionSchemaDetailToJSON,
} from './InformationExtractionSchemaDetail';
import type { DatasetDocument } from './DatasetDocument';
import { DatasetDocumentFromJSON, DatasetDocumentFromJSONTyped, DatasetDocumentToJSON } from './DatasetDocument';

/**
 *
 * @export
 * @interface InformationExtractionDataset
 */
export interface InformationExtractionDataset {
  /**
   *
   * @type {number}
   * @memberof InformationExtractionDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof InformationExtractionDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof InformationExtractionDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {Array<DatasetDocument>}
   * @memberof InformationExtractionDataset
   */
  readonly documents: Array<DatasetDocument>;
  /**
   *
   * @type {InformationExtractionSchemaDetail}
   * @memberof InformationExtractionDataset
   */
  schema: InformationExtractionSchemaDetail;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof InformationExtractionDataset
   */
  language: InformationExtractionLanguageEnum;
}

/**
 * Check if a given object implements the InformationExtractionDataset interface.
 */
export function instanceOfInformationExtractionDataset(value: object): value is InformationExtractionDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('documents' in value) || value['documents'] === undefined) return false;
  if (!('schema' in value) || value['schema'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function InformationExtractionDatasetFromJSON(json: any): InformationExtractionDataset {
  return InformationExtractionDatasetFromJSONTyped(json, false);
}

export function InformationExtractionDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    documents: (json['documents'] as Array<any>).map(DatasetDocumentFromJSON),
    schema: InformationExtractionSchemaDetailFromJSON(json['schema']),
    language: InformationExtractionLanguageEnumFromJSON(json['language']),
  };
}

export function InformationExtractionDatasetToJSON(
  value?: Omit<InformationExtractionDataset, 'id' | 'hasPredictions' | 'documents'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    schema: InformationExtractionSchemaDetailToJSON(value['schema']),
    language: InformationExtractionLanguageEnumToJSON(value['language']),
  };
}
